import type { Event } from '../../types';
import { Button } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';
import { useLearnerEventDetails } from '../../hooks/useLearnerEventDetails';
import { useEventSessionDetails } from '../../hooks/useEventSessionDetails';

type Props = {
  event: Event;
};

const TRANSLATED_REGISTER = I18n.t('js.learner.events.sessions.register_all_sessions');
const TRANSLATED_UNREGISTER = I18n.t('js.learner.events.sessions.unregister_all_sessions');
const TRANSLATED_JOIN_WAITLIST = I18n.t('js.learner.events.sessions.join_waitlist');
const TRANSLATED_REMOVE_FROM_WAITLIST = I18n.t('js.learner.events.sessions.action_button.leave_waitlist');
const TRANSLATED_NO_SEATS_AVAILABLE = I18n.t('js.learner.events.sessions.action_button.no_seats_available');

export const RegisterUnregisterSeriesButton = ({ event }: Props): JSX.Element => {
  const { onRegisterSeries, onUnregisterSeries, onJoinWaitlistSeries, onLeaveWaitlistSeries } =
    useLearnerEventDetails();

  const session = event.trainingClassSessions[0];

  const {
    isLearnerRegistered,
    isLearnerWaitlisted,
    canLearnerJoinWaitlist,
    canLearnerNotJoinWaitlist,
    isDeadlinePast,
  } = useEventSessionDetails(event, session);

  if (isLearnerRegistered) {
    return (
      <Button variant="text" color="secondary" onPress={onUnregisterSeries}>
        {TRANSLATED_UNREGISTER}
      </Button>
    );
  }

  if (isLearnerWaitlisted) {
    return (
      <Button variant="text" color="secondary" onPress={onLeaveWaitlistSeries}>
        {TRANSLATED_REMOVE_FROM_WAITLIST}
      </Button>
    );
  }
  if (canLearnerJoinWaitlist) {
    return <Button onPress={onJoinWaitlistSeries}>{TRANSLATED_JOIN_WAITLIST}</Button>;
  }

  if (canLearnerNotJoinWaitlist) {
    return (
      <Button variant="text" color="secondary" isDisabled>
        {TRANSLATED_NO_SEATS_AVAILABLE}
      </Button>
    );
  }

  return (
    <Button onPress={onRegisterSeries} isDisabled={isDeadlinePast}>
      {TRANSLATED_REGISTER}
    </Button>
  );
};
